// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"56dc6704","769":"ac891433"}[chunkId] + ".chunk.js";
};